import styles from "./TextArea.module.scss";
import classNames from "classnames";

export const TextArea = ({ placeholder, className, ...rest }) => (
  <textarea
    className={classNames(styles.root, className)}
    placeholder={placeholder ? placeholder : "Type something here..."}
    {...rest}
  />
);
